import { RichTextRendererError } from "./RichTextRendererError.js";
const resolveRichTextElementMetadata = (element, metadata) => {
  let reference = void 0;
  if ("referenceId" in element && typeof element["referenceId"] === "string") {
    const resolved = metadata.references?.get(element["referenceId"]);
    if (resolved === void 0) {
      throw new RichTextRendererError(
        `Cannot find reference id '${element["referenceId"]}'` + (metadata.references === void 0 ? ` because its containing block's lacks the '${metadata.referencesField}' field. ` : `.`)
      );
    }
    reference = resolved;
  }
  let referenceRenderer = void 0;
  let referenceType = void 0;
  if (reference && metadata.referenceDiscriminationField) {
    referenceType = reference[metadata.referenceDiscriminationField];
    referenceRenderer = metadata.referenceRenderers[referenceType];
  }
  return {
    formatVersion: metadata.formatVersion,
    reference,
    referenceType,
    referenceRenderer
  };
};
export {
  resolveRichTextElementMetadata
};
//# sourceMappingURL=resolveRichTextElementMetadata.js.map
